import React from 'react';
import { WorkflowBranchEffectDetail } from '../../services/legacyApi';

type FlowActionImpactListProps = {
    effects?: WorkflowBranchEffectDetail[];
    title?: string;
};

export const FlowActionImpactList: React.FC<FlowActionImpactListProps> = ({
    effects = [],
    title = 'Action Impact',
}) => {
    if (!effects.length) return null;
    return (
        <div className="rounded-md border border-amber-200 bg-amber-50 p-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-amber-700">{title}</p>
            <ul className="mt-2 space-y-1">
                {effects.map((effect) => (
                    <li key={effect.code} className="text-sm text-amber-800">
                        <span className="font-medium">{effect.title}:</span> {effect.message}
                    </li>
                ))}
            </ul>
        </div>
    );
};

